import type { FC } from 'react';
import { AccordionLinkGroup } from '../AccordionLinkGroup';
import { useExperienceLinks } from './useExperienceLinks';

export const AccordionExperienceLinks: FC = () => {
    const { data: props, isLoading } = useExperienceLinks();

    if (isLoading || !props) return null;
    return <AccordionLinkGroup {...props} />;
};
